/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ command: NonNullable<unknown> }} Drastic_Tech_Extract_Command_LogInputs */

const en_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Command: ${i?.command}`)
};

const fr_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commande : ${i?.command}`)
};

const de_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Befehl: ${i?.command}`)
};

const it_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
};

const ru_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Команда: ${i?.command}`)
};

const es_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
};

const zh_cn2_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`命令：${i?.command}`)
};

const ja_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`コマンド: ${i?.command}`)
};

const hi_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कमांड: ${i?.command}`)
};

const pt_pt2_drastic_tech_extract_command_log = /** @type {(inputs: Drastic_Tech_Extract_Command_LogInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comando: ${i?.command}`)
};

/**
* | output |
* | --- |
* | "Command: {command}" |
*
* @param {Drastic_Tech_Extract_Command_LogInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_extract_command_log = /** @type {((inputs: Drastic_Tech_Extract_Command_LogInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Extract_Command_LogInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_extract_command_log(inputs)
	if (locale === "de") return de_drastic_tech_extract_command_log(inputs)
	if (locale === "it") return it_drastic_tech_extract_command_log(inputs)
	if (locale === "ru") return ru_drastic_tech_extract_command_log(inputs)
	if (locale === "es") return es_drastic_tech_extract_command_log(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_extract_command_log(inputs)
	if (locale === "ja") return ja_drastic_tech_extract_command_log(inputs)
	if (locale === "hi") return hi_drastic_tech_extract_command_log(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_extract_command_log(inputs)
	return en_drastic_tech_extract_command_log(inputs)
});